// extracted by mini-css-extract-plugin
export default {"root":"NapCarPassLogo-root","logoNap":"NapCarPassLogo-logoNap","logoNapHover":"NapCarPassLogo-logoNapHover","logoCarPass":"NapCarPassLogo-logoCarPass"};